import { useEffect } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

import { useSports } from 'contexts/SportContext';

import { usePrevious } from './usePrevious';

export const useSportRedirect = () => {
  const { sportId } = useSports();
  const previousSport = usePrevious(sportId);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (previousSport !== sportId) {
      const lastUrlChunk = location.pathname.split('/').pop();
      // Checks whether the last part of the url is an ID, if it is - navigate to the root section.
      if (!isNaN(parseInt(lastUrlChunk))) {
        navigate(location.pathname.slice(0, location.pathname.lastIndexOf('/')));
      }
    }
  }, [navigate, location.pathname, sportId, previousSport]);
};
